import {takeLatest, put, call} from 'redux-saga/effects';
import {GET_NEWS_DETAIL_ERROR, GET_NEWS_DETAIL_START, GET_NEWS_DETAIL_SUCCESS} from "../../types";

import apiCall from '../../api/apiGet';

export function* get({payload}) {
  try {
    const url = `/news/`;
    const method = 'GET';
    const headers = {Authorization: 'Bearer ' + payload.token};
    const results = yield call(apiCall, url, method, headers);
    yield put({type: GET_NEWS_DETAIL_SUCCESS, results: results.data});
  } catch (error) {
    yield put({type: GET_NEWS_DETAIL_ERROR, error});
  }
}

export default function* news_detail() {
  yield takeLatest(GET_NEWS_DETAIL_START, get);
}